import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "./pages/Landing";
import ThankYou from "./pages/ThankYou";
import MyOrders from "./pages/MyOrders";
import Admin from "./pages/Admin";
import { Contact, Terms, Privacy, RefundCancellation } from "./pages/Legal";
import { I18nProvider } from "./i18n";

function App() {
  return (
    <I18nProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="/thankyou" element={<ThankYou />} />
            <Route path="/success" element={<ThankYou />} />
            <Route path="/my-orders" element={<MyOrders />} />
            <Route path="/myorders" element={<MyOrders />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/refund-cancellation" element={<RefundCancellation />} />
            <Route path="/refund" element={<RefundCancellation />} />
            <Route path="*" element={<Landing />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="top-center"
          toastOptions={{
            style: {
              background: "#141418",
              border: "1px solid #23232a",
              color: "#f5f5f7",
            },
          }}
        />
      </div>
    </I18nProvider>
  );
}

export default App;
